import type { AdminBootstrapInput } from '../api'
import { api } from '../api'

const adminBootstrap = async (data: AdminBootstrapInput) => {
  return await api.v1.adminBootstrap(data)
}

export default {
  adminBootstrap,
}
